import CreateDeviceContent from "./CreateDeviceContent";

export default CreateDeviceContent;